import { render } from "./CustomRef.vue?vue&type=template&id=06c4be06"
import script from "./CustomRef.vue?vue&type=script&lang=ts"
export * from "./CustomRef.vue?vue&type=script&lang=ts"
script.render = render

export default script